import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import Mixpanel from "mixpanel-browser";
import PhoneInput from "react-phone-input-2";
import TagManager from 'react-gtm-module';

import Fields from "../components/form-components/Fields";
import Button from "../components/form-components/Button";
import Image from "../components/form-components/Image";

import { signup } from "../features/auth/signup/signupSlice";
import { CREATED } from "../constants/statusCode";
import { setSession } from "../utils/localSession";

import logo from "../assets/images/DocoMatic_beta.svg";
import eyeline from "../assets/images/eyelineicn.svg";
import eye from "../assets/images/eyeicn.svg";
import "react-phone-input-2/lib/style.css";
import signupPageValidations from "../validations/auth/signupPageValidations";
import axios from "axios";
import { showError } from "../utils/messageHelper";

export default function Signup() {
  const [code, setCode] = useState("");
  const [codeMobile, setCodeMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [mobile, setMobile] = useState("");

  const [togglePassword, setTogglePassword] = useState(false);

  const getUserIp = async () => {
    // const response = await fetch("https://api.ipify.org?format=json");
    // const data = await response.json();
    // return data;
    const response = await axios.get("https://ipapi.co/json/");
    let { data } = response;
    setCode(data.country.toLowerCase());
  };

  useEffect(() => {
    // async function fetchData() {
    //   const { ip } = await getUserIp();
    //   const response = await fetch(
    //     `http://ip-api.com/json/${ip}?fields=countryCode`
    //   );
    //   const data = await response.json();
    //   setCode(data.countryCode.toLowerCase());
    // }
    // fetchData();
    getUserIp();
  }, []);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const mobileNumberHandler = (value, code) => {
    setCode(code?.dialCode);
    setCodeMobile(value);
    let number = value.substring(code?.dialCode?.length);
    setMobile(number);
    if (number && !(number.length > 7 && number.length < 12)) {
      setMobileError("Mobile number must be 8 to 11 digits.");
    } else {
      setMobileError("");
    }
  };

  const validate = (values) => {
    const errors = {};
    if (mobile) {
      values.mobile = mobile;
    }
    if (
      values.mobile &&
      !(values.mobile.length > 7 && values.mobile.length < 12)
    ) {
      errors.mobile = "Mobile number must be 8 to 11 digits.";
      setMobileError(errors.mobile);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          mobile: codeMobile,
          phone: "",
          isd_code: code,
          organization_name: "",
          website_url: "",
        }}
        validate={validate}
        validationSchema={signupPageValidations}
        onSubmit={async (values) => {
          if (
            values.mobile &&
            !(values.mobile.length >= 8 && values.mobile.length < 12)
          ) {
            setMobileError("Mobile number must be 8 to 11 digits.");
          } else {
            values.mobile = mobile;
            values.isd_code = code;
            Mixpanel.track("Signup button clicked", { Page: "Signup page" });
            const { payload } = await dispatch(signup(values));
            if (payload.status === CREATED) {
              TagManager.dataLayer({
                event: 'registerSuccess'
              });
              Mixpanel.identify(payload.data.responseData.user.id);
              Mixpanel.alias(payload.data.responseData.user.id);
              Mixpanel.people.set({
                '$first_name': values.first_name,
                '$last_name': values.last_name,
                '$email': values.email,
              });
              setSession(
                payload.data.responseData.access_token,
                "",
                payload.data.responseData.user.uuid,
                payload.data.responseData.user
              );
              navigate("/dashboard");
            } else {
              showError(payload?.response?.data?.responseMessage);
            }
          }
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          isSubmitting,
          handleSubmit,
          setFieldValue,
        }) => (
          <Form>
            <div className="form-pages d-flex align-items-center">
              <div className="form-box">
                <span className="logo text-center">
                  <Image src={logo} alt="" />
                </span>
                <h1>AI-Powered Chatbot for Documents</h1>

                <div className="row gx-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <Fields
                        type="text"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="first_name"
                        value={values.first_name}
                        placeholder="First Name"
                        className="form-control"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <Fields
                        type="text"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="last_name"
                        value={values.last_name}
                        placeholder="Last Name"
                        className="form-control"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <Fields
                    type="email"
                    placeholder="Email"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="email"
                    value={values.email}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group form-grp-passsword">
                  <Fields
                    type={togglePassword ? "text" : "password"}
                    placeholder="Password"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="password"
                    value={values.password}
                    className="form-control"
                    onChange={handleChange}
                  />
                  <span
                    className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                    onClick={() => setTogglePassword(!togglePassword)}
                  >
                    <img
                      className="eye-icn"
                      src={togglePassword ? eye : eyeline}
                      alt="show password"
                    />
                  </span>
                </div>
                <div className="form-group">
                  <PhoneInput
                    country={code ? code : "us"}
                    name="mobile"
                    id="mobile"
                    searchPlaceholder="Search country"
                    disableInitialCountryGuess={false}
                    enableLongNumbers={true}
                    countryCodeEditable={false}
                    onChange={mobileNumberHandler}
                    value={codeMobile}
                    enableSearch={true}
                  />
                  <span className="hint">
                    <div className="mt-0 mx-0">
                      <div className="text-start text-danger mb-2 mt-2">
                        {mobileError}
                      </div>
                    </div>
                  </span>
                </div>
                <div className="form-group addon-block">
                  <Fields
                    type="text"
                    placeholder="Organisation Name"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="organization_name"
                    value={values.organization_name}
                    className="form-control"
                    onChange={handleChange}
                  />
                  {/* <span className="addon-note">.thecloudtutorialusers.com</span> */}
                </div>
                {/* <div className="form-group addon-block">
                  <Fields
                    type="text"
                    placeholder="Organization Name"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="company_name"
                    value={values.company_name}
                    className="form-control"
                    onChange={handleChange}
                  />
                  <span className="addon-note">.thecloudtutorialusers.com</span>
                </div>

                <div className="form-group">
                  <Fields
                    type="text"
                    placeholder="Website"
                    touched={touched}
                    errors={errors}
                    onBlur={handleBlur}
                    name="website_url"
                    value={values.website_url}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div> */}

                <div className="form-group">
                  <Button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 mt-1"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    Sign Up
                  </Button>
                </div>
                <div className="form-group mt-1">
                  <p className="form-msg">
                    By creating account, I agree to{" "}
                    <a
                      href="https://www.docomatic.ai/terms-of-use/"
                      target={"_blank"}
                    >
                      {" "}
                      Terms of Use
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.docomatic.ai/privacy-policy/"
                      target={"_blank"}
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div>
                <h4>
                  Already have an account?{" "}
                  <Link to="/login" className="form-link">
                    Sign In
                  </Link>
                </h4>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
